// Détection « appareil mobile » pour basculer vers l'UI mobile dédiée.
// Mobile si l'user-agent correspond à un smartphone/tablette OU si la largeur < 768px.
import { useState, useEffect } from 'react';

const MOBILE_UA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Silk/i;
const MOBILE_MAX_WIDTH = 768;

export const detectIsMobile = () => {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  const byUa = MOBILE_UA.test(ua);
  const byWidth = window.innerWidth > 0 && window.innerWidth < MOBILE_MAX_WIDTH;
  // iPadOS récent se présente comme un Mac : détecter le tactile multipoint.
  const iPadOS = navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1;
  return byUa || byWidth || iPadOS;
};

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(detectIsMobile);

  useEffect(() => {
    const onResize = () => setIsMobile(detectIsMobile());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  return isMobile;
}
